import { render, staticRenderFns } from "./DpaAccountForm.vue?vue&type=template&id=7091e754&"
import script from "./DpaAccountForm.vue?vue&type=script&lang=js&"
export * from "./DpaAccountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports